export const SHARE_TYPES = {
  TWITTER: 'Twitter',
  WHATSAPP: 'Whatsapp',
  EMAIL: 'Email',
  LINK: 'Copy Link',
} as const

export type ShareTypeName = (typeof SHARE_TYPES)[keyof typeof SHARE_TYPES]
